import { ThemedText } from "@/components/themed-text";
import Ionicons from "@react-native-vector-icons/ionicons";
import React from "react";
import { StyleSheet, View } from "react-native";

export const TIER_COLORS: Record<string, { background: string; text: string }> = {
  bronze: { background: "#FEF3C7", text: "#B45309" },
  silver: { background: "#E2E8F0", text: "#475569" },
  gold: { background: "#FEF9C3", text: "#A16207" },
};

export function loyaltyTierLabel(tier?: string | null): string | null {
  if (!tier) {
    return null;
  }

  return tier.charAt(0).toUpperCase() + tier.slice(1);
}

interface LoyaltyBadgesProps {
  loyaltyTier?: string | null;
  isTopRated?: boolean;
}

export function LoyaltyBadges({ loyaltyTier, isTopRated }: LoyaltyBadgesProps) {
  const label = loyaltyTierLabel(loyaltyTier);

  if (!label && !isTopRated) {
    return null;
  }

  const colors = TIER_COLORS[loyaltyTier ?? ""] ?? TIER_COLORS.bronze;

  return (
    <View style={styles.row}>
      {label ? (
        <View style={[styles.chip, { backgroundColor: colors.background }]}>
          <ThemedText style={[styles.chipText, { color: colors.text }]}>
            {label}
          </ThemedText>
        </View>
      ) : null}
      {isTopRated ? (
        <View style={[styles.chip, styles.topRated]}>
          <Ionicons name="star" size={10} color="#16A34A" />
          <ThemedText style={[styles.chipText, styles.topRatedText]}>
            Top rated
          </ThemedText>
        </View>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 6,
  },
  chip: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    borderRadius: 20,
    paddingHorizontal: 8,
    paddingVertical: 3,
  },
  chipText: {
    fontSize: 11,
    fontWeight: "700",
  },
  topRated: {
    backgroundColor: "#DCFCE7",
  },
  topRatedText: {
    color: "#16A34A",
  },
});
